module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-8.a290bf56.jpg";